"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DARK_COLORS = exports.CLASSIC_COLORS = exports.baseColorMap = exports.PURPLE_TRANSLUCENT = exports.WHITE_TRANSLUCENT = exports.GRAY_TRANSLUCENT = exports.GRAY = exports.ORANGE = exports.PINK = exports.AQUA = exports.GREEN = exports.BLUE = exports.RED = exports.YELLOW = exports.PURPLE = void 0;

var _utils = require("@tablekit/utils");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var PURPLE = {
  L1: '#EAE6F4',
  L2: '#C7B6F1',
  L3: '#A988EC',
  L4: '#9464E3',
  L5: '#7935D2',
  L6: '#6B20BF',
  L7: '#5C11A6',
  L8: '#4A0787',
  L9: '#370466'
};
exports.PURPLE = PURPLE;
var YELLOW = {
  L1: '#FFF7CC',
  L2: '#FEED9B',
  L3: '#FBE06C',
  L4: '#F7D147',
  L5: '#F2C02A',
  L6: '#EAAD15',
  L7: '#E0990B',
  L8: '#D18800',
  L9: '#BC7401'
};
exports.YELLOW = YELLOW;
var RED = {
  L1: '#FEEBE7',
  L2: '#FBC4BB',
  L3: '#EF877A',
  L4: '#E85B50',
  L5: '#DF3730',
  L6: '#CE1F1B',
  L7: '#B40C0D',
  L8: '#8B0217',
  L9: '#56000D'
};
exports.RED = RED;
var BLUE = {
  L1: '#E2F2FE',
  L2: '#B3D7FF',
  L3: '#86BAFD',
  L4: '#5192FC',
  L5: '#276BE5',
  L6: '#0A4BC9',
  L7: '#0034A4',
  L8: '#032877',
  L9: '#001A52'
};
exports.BLUE = BLUE;
var GREEN = {
  L1: '#E8F7D9',
  L2: '#CEF3B9',
  L3: '#A7DF90',
  L4: '#79CD60',
  L5: '#55B937',
  L6: '#3D9B31',
  L7: '#327529',
  L8: '#235922',
  L9: '#1E431E'
};
exports.GREEN = GREEN;
var AQUA = {
  L1: '#E4F1F1',
  L2: '#B6ECED',
  L3: '#85D9E0',
  L4: '#58C4D5',
  L5: '#31ADC6',
  L6: '#1D8DAA',
  L7: '#0E708B',
  L8: '#07536A',
  L9: '#033A49'
};
exports.AQUA = AQUA;
var PINK = {
  L1: '#FDEDEF',
  L2: '#FCCFDA',
  L3: '#F6A7BB',
  L4: '#F4809D',
  L5: '#E75A82',
  L6: '#DD3C69',
  L7: '#BE2D53',
  L8: '#962241',
  L9: '#68182D'
};
exports.PINK = PINK;
var ORANGE = {
  L1: '#FFEDE5',
  L2: '#FFCFB3',
  L3: '#FDA968',
  L4: '#FA893D',
  L5: '#F3671B',
  L6: '#E25103',
  L7: '#BD3C00',
  L8: '#942F00',
  L9: '#611D00'
};
exports.ORANGE = ORANGE;
var GRAY = {
  L1: '#F8F8F8',
  L2: '#F2F2F2',
  L3: '#E4E4E4',
  L4: '#D2D2D2',
  L5: '#939393',
  L6: '#757575',
  L7: '#575757',
  L8: '#323232',
  L9: '#212121'
};
exports.GRAY = GRAY;
var GRAY_TRANSLUCENT = {
  L1: 'rgba(0, 0, 0, 0.03)',
  L2: 'rgba(0, 0, 0, 0.05)',
  L3: 'rgba(0, 0, 0, 0.11)',
  L4: 'rgba(0, 0, 0, 0.18)',
  L5: 'rgba(0, 0, 0, 0.42)',
  L6: 'rgba(0, 0, 0, 0.54)',
  L7: 'rgba(0, 0, 0, 0.66)',
  L8: 'rgba(0, 0, 0, 0.80)',
  L9: 'rgba(0, 0, 0, 0.87)'
};
exports.GRAY_TRANSLUCENT = GRAY_TRANSLUCENT;
var WHITE_TRANSLUCENT = {
  L1: 'rgba(255, 255, 255, 0.03)',
  L2: 'rgba(255, 255, 255, 0.05)',
  L3: 'rgba(255, 255, 255, 0.11)',
  L4: 'rgba(255, 255, 255, 0.18)',
  L5: 'rgba(255, 255, 255, 0.42)',
  L6: 'rgba(255, 255, 255, 0.54)',
  L7: 'rgba(255, 255, 255, 0.66)',
  L8: 'rgba(255, 255, 255, 0.80)',
  L9: 'rgba(255, 255, 255, 0.87)'
};
exports.WHITE_TRANSLUCENT = WHITE_TRANSLUCENT;
var PURPLE_TRANSLUCENT = {
  L1: (0, _utils.hexToRgba)(PURPLE.L5, 0.1),
  L2: (0, _utils.hexToRgba)(PURPLE.L5, 0.2),
  L3: (0, _utils.hexToRgba)(PURPLE.L5, 0.3),
  L4: (0, _utils.hexToRgba)(PURPLE.L5, 0.4),
  L5: (0, _utils.hexToRgba)(PURPLE.L5, 0.5),
  L6: (0, _utils.hexToRgba)(PURPLE.L5, 0.6),
  L7: (0, _utils.hexToRgba)(PURPLE.L5, 0.7),
  L8: (0, _utils.hexToRgba)(PURPLE.L5, 0.8),
  L9: (0, _utils.hexToRgba)(PURPLE.L5, 0.9)
};
exports.PURPLE_TRANSLUCENT = PURPLE_TRANSLUCENT;
var baseColorMap = {
  PURPLE: _objectSpread({}, PURPLE),
  YELLOW: _objectSpread({}, YELLOW),
  RED: _objectSpread({}, RED),
  BLUE: _objectSpread({}, BLUE),
  GREEN: _objectSpread({}, GREEN),
  AQUA: _objectSpread({}, AQUA),
  PINK: _objectSpread({}, PINK),
  ORANGE: _objectSpread({}, ORANGE),
  GRAY: _objectSpread({}, GRAY),
  GRAY_TRANSLUCENT: _objectSpread({}, GRAY_TRANSLUCENT),
  WHITE_TRANSLUCENT: _objectSpread({}, WHITE_TRANSLUCENT),
  PURPLE_TRANSLUCENT: _objectSpread({}, PURPLE_TRANSLUCENT)
}; // These two exportable objects should have the same keys
// and be referenced via the colorResolver function

exports.baseColorMap = baseColorMap;
var CLASSIC_COLORS = Object.freeze({
  canvas: GRAY.L1,
  // background for the lowest level of the page, i.e. <body>
  primary: PURPLE.L5,
  primary2: PURPLE.L7,
  secondary: BLUE.L5,
  secondary2: BLUE.L4,
  accent: YELLOW.L4,
  success: GREEN.L5,
  warning: YELLOW.L5,
  danger: RED.L5,
  text: GRAY.L8,
  // generic text color
  textSubtle: GRAY_TRANSLUCENT.L6,
  // for text that has to be a bit more dimmed down
  surface: 'white',
  // usually for cards background
  surfaceHigh: WHITE_TRANSLUCENT.L9,
  // for bgs above the surface level
  surfaceLow: GRAY_TRANSLUCENT.L3,
  // for bgs below the surface level and above the canvas level
  border: GRAY_TRANSLUCENT.L3,
  // generic border color for inputs, menu separators, etc
  inputBackground: WHITE_TRANSLUCENT.L4,
  // background color for text fields, textareas and selects
  iconFill: GRAY_TRANSLUCENT.L7,
  hoverNeutralBackground: GRAY_TRANSLUCENT.L2,
  // hover bg for comp without colour like items
  hoverPrimaryBackground: PURPLE_TRANSLUCENT.L1,
  selectedBackground: PURPLE_TRANSLUCENT.L2,
  // used in items, tables
  disabledBackground: GRAY_TRANSLUCENT.L3
});
exports.CLASSIC_COLORS = CLASSIC_COLORS;
var DARK_COLORS = Object.freeze({
  canvas: GRAY.L9,
  primary: PURPLE.L5,
  primary2: PURPLE.L3,
  secondary: BLUE.L5,
  secondary2: BLUE.L4,
  accent: YELLOW.L4,
  success: GREEN.L6,
  warning: YELLOW.L6,
  danger: RED.L6,
  text: WHITE_TRANSLUCENT.L9,
  textSubtle: WHITE_TRANSLUCENT.L6,
  surface: GRAY.L8,
  surfaceHigh: WHITE_TRANSLUCENT.L4,
  surfaceLow: GRAY_TRANSLUCENT.L4,
  border: WHITE_TRANSLUCENT.L4,
  inputBackground: WHITE_TRANSLUCENT.L1,
  iconFill: WHITE_TRANSLUCENT.L8,
  hoverNeutralBackground: WHITE_TRANSLUCENT.L3,
  hoverPrimaryBackground: PURPLE_TRANSLUCENT.L2,
  selectedBackground: PURPLE_TRANSLUCENT.L3,
  disabledBackground: WHITE_TRANSLUCENT.L4
});
exports.DARK_COLORS = DARK_COLORS;
var _default = baseColorMap;
exports["default"] = _default;